import { Row } from 'blocks/CommonLayout';
import { Title } from 'blocks/Text';
import { CardProps } from './card.interface';
import StyledCard from './card.styles';

const Card = ({
  children,
  space = 'medium',
  boxShadow = 'normal',
  className,
  style,
  title,
  titleContent,
  color = 'white',
  bordered,
}: CardProps) => {
  return (
    <StyledCard className={`card ${space} ${boxShadow} ${className}`} color={color} bordered={bordered} style={style}>
      {title && (
        <Row className="card__head" justify="space-between" align="center">
          {typeof title === 'string' ? (
            <Title size="medium" bold={false}>
              {title}
            </Title>
          ) : (
            title
          )}
          {titleContent && <div className="title-content">{titleContent}</div>}
        </Row>
      )}
      {children}
    </StyledCard>
  );
};

export default Card;
